import {
  Component,
  EventEmitter,
  Input,
  Output,
  TemplateRef,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import { ModalService } from '../../services/modal.service';
import { NgTemplateOutlet } from '@angular/common';
import { IconComponent } from '../icon/icon.component';

@Component({
    selector: 'fk-modal-base-container',
    templateUrl: './modal-base-container.component.html',
    styleUrl: './modal-base-container.component.scss',
    imports: [NgTemplateOutlet, IconComponent]
})
export class ModalBaseContainerComponent {
  @ViewChild('modalHeaderBase', { static: true })
  public modalHeaderBase!: TemplateRef<any>;

  @ViewChild('modalFooterBase', { static: true })
  public modalFooterBase!: TemplateRef<any>;

  @ViewChild('container', { read: ViewContainerRef, static: true })
  public container!: ViewContainerRef;

  @Input()
  public header!: TemplateRef<any>;

  @Input()
  public footer!: TemplateRef<any>;

  @Input()
  public title: string = '';

  @Input()
  public width: string = 'auto';

  @Input()
  public height: string = 'auto';

  @Output()
  public modalClosed: EventEmitter<void> = new EventEmitter();

  constructor (
    private readonly _modal: ModalService,
  ) { }

  public onCloseModal() {
    this.modalClosed.emit();
    this._modal.hide();
  }
}
